<svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-6 w-6"
>
    <path
        d="M3.33594 5.83333H16.6693M15.8359 5.83333L15.1134 15.9517C15.0835 16.3722 14.8953 16.7657 14.5869 17.053C14.2784 17.3403 13.8725 17.5 13.4509 17.5H6.55427C6.13272 17.5 5.72683 17.3403 5.41834 17.053C5.10986 16.7657 4.9217 16.3722 4.89177 15.9517L4.16927 5.83333H15.8359ZM12.5026 5.83333V3.33333C12.5026 3.11232 12.4148 2.90036 12.2585 2.74408C12.1022 2.5878 11.8903 2.5 11.6693 2.5H8.33594C8.11492 2.5 7.90296 2.5878 7.74668 2.74408C7.5904 2.90036 7.5026 3.11232 7.5026 3.33333V5.83333H12.5026Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
    <path
        d="M9 12.5L7 10.5M7 10.5L9 8.5M7 10.5H11C11.5304 10.5 12.0391 10.7107 12.4142 11.0858C12.7893 11.4609 13 11.9696 13 12.5C13 13.0304 12.7893 13.5391 12.4142 13.9142C12.0391 14.2893 11.5304 14.5 11 14.5H10"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
    />
</svg>
